<template>
  <div>
    <div class="searchDiv">
      <el-input class="searchInput" v-model="params.blurry" placeholder="请输入用户名或昵称" clearable></el-input>
      <el-button type="primary" @click="getUserList">查询</el-button>
      <el-button v-if="hasPer('user:add')" @click="editUser" style="float: right;">新增</el-button>
    </div>
    <el-table :data="tableData" row-key="id" border>
      <el-table-column label="账号" prop="username"></el-table-column>
      <el-table-column label="昵称" prop="nickName"></el-table-column>
      <el-table-column label="角色" prop="roleNames" width="450"></el-table-column>
      <el-table-column label="部门" prop="positionsName"></el-table-column>
      <el-table-column label="状态" prop="enabled">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.enabled" type="success" size="mini">启用</el-tag>
          <el-tag v-else type="danger" size="mini">停用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="option" width="500px" align="center">
        <template slot-scope="scope">
          <el-button v-if="hasPer('user:enabled')" :type="buttonType(scope.row.enabled)"
                     @click="enabledUser(JSON.parse(JSON.stringify(scope.row)))">
            {{scope.row.enabled ? '停用' : '启用'}}</el-button>
          <el-button v-if="hasPer('user:achievement')" type="primary" @click="editUserAim(JSON.parse(JSON.stringify(scope.row)))">绩效考核</el-button>
          <el-button v-if="hasPer('user:edit')" type="primary" @click="editUser(JSON.parse(JSON.stringify(scope.row)))">编辑</el-button>
          <el-button v-if="hasPer('user:del')" type="danger" @click="delUser(scope.row.id, scope.row.username)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <pagination
        :current.sync="params.current"
        :size.sync="params.size"
        :total="params.total"
        @get-list="getUserList"
    >
    </pagination>
    <!--编辑-->
    <edit-user :dialog-visible.sync="dialogVisible" :user-obj="userObj" @get-list="getUserList"></edit-user>
    <achievement :dialog-visible.sync="achieveVisible" :username="userAim"></achievement>
  </div>
</template>

<script>
import editUser from "./editUser.vue";
import achievement from "./achievement.vue";
import Pagination from "../../../components/Pagination.vue";
import {delUser, enabledUser, getUserList} from "../../../api/sys/user/sysUser";
import {infoMsg, successMsg} from "../../../utils/message";
import {hasPer} from "../../../utils/common";
import store from "../../../store";

export default {
  name: "index",
  components: {
    Pagination,
    editUser,
    achievement
  },
  data(){
    return{
      username: store.state.userInfo.username,
      tableData: [],
      dialogVisible: false,
      achieveVisible: false,
      userObj: {},
      userAim: "",
      params:{
        blurry: '',
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  mounted() {
    this.getUserList()
  },
  methods: {
    hasPer,
    getUserList(){
      getUserList(this.params).then(res => {
        this.tableData = res.records
        this.params.total = res.total
        this.params.current = res.current
        this.params.size = res.size
      })
    },
    editUser(row){
      this.dialogVisible = true
      this.userObj = row.id ? row : {}
    },
    editUserAim(row){
      this.achieveVisible = true
      this.userAim = row.username
    },
    delUser(id, username){
      this.$confirm('确定删除用户【' + username + '】？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delUser({id: id}).then(() => {
          successMsg('操作成功')
          this.getUserList()
        })
      }).catch(() => {
        infoMsg('操作已取消')
      })
    },
    //  启用/停用用户
    enabledUser(row){
      row.enabled = !row.enabled
      const str = row.enabled ? '启用' : '停用'
      const color = row.enabled ? '#c2c03a' : '#F56C6C'
      this.$confirm('确定<span style="color: '+color+'">' + str + '</span>用户【' + row.nickName + '】？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        enabledUser(row).then(() => {
          successMsg('操作成功')
          this.getUserList()
        })
      }).catch(() => {
        infoMsg('操作已取消')
      })
    },
    buttonType(type){
      if (type){
        return 'warning'
      } else {
        return 'success'
      }
    }
  }
}
</script>

<style scoped>

</style>
